var EHDI = EHDI || Object.create(null);

EHDI.component = EHDI.component || Object.create(null);

EHDI.component.TutorialOverlay = function() {
    EHDI.aka.Container.call(this);
    
    var _this = this;
    
    /*
    this.pointer = new EHDI.aka.Sprite( EHDI.Assets.images["ui_htp_hand"] );
    this.pointer.anchor.set( 0.5, 0.0 );
    this.addChild( this.pointer );
    this.pointerPos = { x: 0, y: 0 };
    //*/
        
    var _messageContainer = new EHDI.aka.Sprite( EHDI.Assets.images["WB_con_note"] );
    _messageContainer.anchor.set( 0.5, 0.5 );
    this.addChild( _messageContainer );
        
    var _messageTxt = new EHDI.aka.PixiText(EHDI.localization.strings["tut"].content,
        {   
            fontFamily: 'nuevastd-bold',
            fontSize: EHDI.localization.strings["tut"].size,
            wordWrap: true,
            align: 'center',
            fill: '#000000',
            wordWrapWidth: _messageContainer.width * 0.85
        }
    );
    _messageTxt.anchor.set(0.5, 0.5);
    //_messageTxt.position.y = _messageContainer.height * 0.03;
    _messageContainer.addChild( _messageTxt );
    _messagePos = { x: 0, y: 0 };
    
    _messageContainer.scale.set( 0, 0 );
    //_pointer.scale.set( 0, 0 );
    
    this.updateMessage = function( message, posX, posY ){
        _this.setMessageText( message );
        _this.setMessagePos( posX, posY );
        _this.showMessage();
    }
    
    this.setMessagePos = function( posX, posY ){
        _messagePos.x = posX;
        _messagePos.y = posY;
        _messageContainer.position.set( EHDI.screen.viewWidth * posX, EHDI.screen.viewHeight * posY );
    }
    
    this.setMessageText = function( message ){
        _messageTxt.text = message;
        _messageTxt.scale.set( 0 );
        TweenMax.to( _messageTxt.scale, 0.2, { x: 1, y: 1 } );
    }
    
    this.showMessage = function(){
        TweenMax.to( _messageContainer.scale, 0.2, { x: 1, y: 1 } );
    }
    
    this.hideMessage = function(){
        TweenMax.to( _messageContainer.scale, 0.2, { x: 0, y: 0 } );
    }
    
    /*
    this.setPointerPos = function( posX, posY ){
        this.pointerPos.x = posX;
        this.pointerPos.y = posY;
        
        this.pointer.position.set( EHDI.screen.viewWidth * this.pointerPos.x, EHDI.screen.viewHeight * this.pointerPos.y );
        TweenMax.to( this.pointer.scale, 0.2, { x: 1, y: 1 } );
    }
    
    this.movePointerTo = function( posX, posY, duration ){
        this.pointerPos.x = posX / EHDI.screen.viewWidth;
        this.pointerPos.y = posY / EHDI.screen.viewHeight;
        TweenMax.to( this.pointer, duration, { x: posX, y: posY } );
    }
    
    this.playHoverAnim = function(){
        TweenMax.to( this.pointer.scale, 0.2, {
            x: 0.9, y: 0.9,
            yoyo: true, repeat: 1
        } );
    }
    
    this.hidePointer = function(){
        TweenMax.to( this.pointer.scale, 0.2, { x: 0, y: 0 } );
    }
    //*/
    
    this.onScreenResize = function( pointerX, pointerY ){
        //pointerX = pointerX === undefined ? EHDI.screen.viewWidth * this.pointerPos.x : pointerX;
        //pointerY = pointerY === undefined ? EHDI.screen.viewHeight * this.pointerPos.y : pointerY;
        
        _messageContainer.position.set( EHDI.screen.viewWidth * _messagePos.x, EHDI.screen.viewHeight * _messagePos.y );
        //this.pointer.position.set( pointerX, pointerY );
    }
    
    this.destroy = function(){
        this.super.prototype.destroy.apply(this, arguments);
    }
}

EHDI.component.TutorialOverlay.prototype = Object.create(EHDI.aka.Container.prototype);